import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachepulsarComponent } from './simple-icons-apachepulsar.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachepulsarComponent ],
    exports:      [ SimpleIconsApachepulsarComponent ],
    bootstrap:    []
})
export class SimpleIconsApachepulsarModule {}
